<template>
  <div class="capability-chooser">
    <label class="capability-chooser__label">
      <span class="capability-chooser__label-text">{{ $t('message.capability') }}</span>
      <span class="capability-chooser__value">
        <span class="capability-chooser__value-sup">{{ value }} {{ $t('measure.m3') }}</span>
        <span class="capability-chooser__value-sub">/{{ $t('message.day') }}</span>
      </span>
    </label>
    <b-form-input :max="max" :min="min" :value="value" @input="onChange($event)" type="range"/>
  </div>
</template>

<script>
  export default {
    name: "CapabilityChooser",
    model: {
      prop: 'value',
      event: 'change'
    },
    props: {
      value: {
        type: Number,
        default: 1
      },
      min: {
        type: Number,
        default: 1
      },
      max: {
        type: Number,
        default: Infinity
      }
    },
    methods: {
      onChange(value) {
        this.$emit('change', parseInt(value));
      }
    },
  }
</script>

<style scoped>
  .capability-chooser {
    margin: 2em 0;
  }

  .capability-chooser__label {
    display: flex;
    align-items: flex-end;
    align-content: space-between;
  }

  .capability-chooser__label-text {
    margin-right: auto;
  }

  .capability-chooser__value {
    text-align: right;
  }

  .capability-chooser__value {
    text-align: center;
  }

  .capability-chooser__value-sup {
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 32px;
  }

  .capability-chooser__value-sub {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 24px;
  }
</style>
